import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrderDetailScreen } from '@/features/sales-orders/order-detail-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one sales order. `.index` keeps this a sibling of
 * `orders.new.tsx` and `orders.$orderId.edit.tsx` under `orders.tsx`'s own
 * Outlet — mirrors `_authenticated/purchasing/orders.$orderId.index.tsx`.
 */
export const Route = createFileRoute('/_authenticated/sales/orders/$orderId/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'sales_order.view')) {
      throw redirect({ to: '/sales/orders' })
    }
  },
  component: SalesOrderDetailRoute,
})

function SalesOrderDetailRoute() {
  const { orderId } = Route.useParams()

  return <OrderDetailScreen orderId={orderId} />
}
